import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { UsuarioModel } from '../models/usuario.model';
import { Subject, Observable, throwError } from 'rxjs';
import { Injectable, EventEmitter, Renderer2 } from '@angular/core';
import { map, catchError, timeoutWith } from 'rxjs/operators';
import { ConstantesService } from './services/constantes.service';
import { AssetsService } from './services/assets.service';

@Injectable()
export class GlobalService {

  itemValue = new Subject();
  usuario: UsuarioModel = new UsuarioModel('', '', '', '', '');
  apiKey: string = null;
  userId: string = null;
  userName: string = null;
  token: string = null;
  expiracionToken = new EventEmitter();
  rolSeleccionado: string;
  permisosUsuario: any[] = [];
  contadorUAC = new Subject();
  tamanoletra: any;
  style: any;
  currentTheme: any;
  icon: any;
  public estadoConexionAplicacion: Subject<string>;
  zonaCompartida: any;


  constructor(private http: HttpClient) {
    this.zonaCompartida = {};
    this.estadoConexionAplicacion = new Subject<string>();
  }

  public buildHeaders(contentJSON: boolean, urlReq: string, noSeguro?: boolean) {
    let headers = new HttpHeaders();
    if (!noSeguro) {
      this.createSecurityOptions(headers, urlReq.includes('auth'));
      const obj = this.cargaSessionContext();
      headers = headers.append(ConstantesService.SESSION_CONTEXT, JSON.stringify(obj));
      headers = this.cargarInformacionSDK(headers);
    }
    if (contentJSON) {
      headers = headers.append('Content-Type', 'application/json');
    }
    return headers;
  }

  public cargarInformacionSDK(headers) {
    headers = headers.append(ConstantesService.ACCESS_TOKEN, sessionStorage.getItem(ConstantesService.TOKEN_HEADER));
    headers = headers.append(ConstantesService.CLIENT_ID, sessionStorage.getItem(ConstantesService.HEADER_ID_APLICACION));
    headers = headers.append(ConstantesService.USER_ID, sessionStorage.getItem(ConstantesService.SIA3_SESSSION));
    // headers = headers.append('prueba','1234345546');
    return headers;
  }


  private cargaSessionContext() {
    const obj = {};
    obj[ConstantesService.USER_ID_HEADER] = sessionStorage.getItem(ConstantesService.SIA3_SESSSION);
    obj[ConstantesService.TOKEN_EXP_DATE_HEADER] = sessionStorage.getItem(ConstantesService.TOKEN_EXP_DATE_HEADER);
    obj[ConstantesService.TIPO_DOC_SESSSION] = sessionStorage.getItem(ConstantesService.TIPO_DOC_SESSSION);
    obj[ConstantesService.NUMBER_HEADER] = sessionStorage.getItem(ConstantesService.NUM_DOC_SESSSION);
    return obj;
  }

  private createSecurityOptions(headers: HttpHeaders, envPass?: boolean) {
    headers = headers.append('Authorization', 'Bearer ' + sessionStorage.getItem(ConstantesService.TOKEN_HEADER));
  }

  public postGenerico(url: string, cuerpo?: any): any {
    const headers = this.buildHeaders(true, url);
    const options = { headers };
    return this.http.post(url, cuerpo, options).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }

  public getGenerico(url: string): any {
    const headers = this.buildHeaders(true, url);

    const options = { headers };
    return this.http.get(url, options).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }

  public getPublico(url: string): any {
    const headers = this.buildHeaders(false, url, true);

    const options = { headers };
    return this.http.get(url, options).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }

  public postPublico(url: string, cuerpo?: any): any {
    const headers = this.buildHeaders(true, url, true);
    const options = { headers };
    return this.http.post(url, cuerpo, options).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }

  putGenerico(url: string, req: any): Observable<any> {
    const body = req;
    const headers = this.buildHeaders(true, url);
    const options = { headers };
    return this.http.put(url, body, options).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }

  public get(url: string, noSeguro?: boolean): any {
    const headers = this.buildHeaders(true, url, noSeguro);

    const options = new Object({ headers, responseType: 'text' });
    return this.http.get(url, options).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }

  public post(url: string, cuerpo?: any): any {
    const headers = this.buildHeaders(false, url);

    const options = new Object({ headers, responseType: 'text' });
    return this.http.post(url, cuerpo, options).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }

  public getNoMap(url: string): any {
    const headers = this.buildHeaders(false, url);
    const options = new Object({ headers, responseType: 'blob' as 'json' });
    return this.http.get(url, options).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }

  public getSIA3(url: string) {
    return this.http.get(url).pipe(
      timeoutWith(30000,
        throwError('Tiempo Máximo Excedido')
      ),
      map(this.extractData),
      catchError(this.handleError)
    );
  }

  public postSIA3(url: string) {
    const header = {
      ipHost: window.location.origin,
      apiKey: this.apiKey,
      userId: this.userId
    };
    const tokenAcceso = sessionStorage.getItem('Token');
    const body = { header, tokenAcceso };

    return this.http.post(url, body).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }

  public postTr(url: string, cuerpo?: any): any {
    return this.http.post(url, cuerpo);
  }

  private extractData(res) {
    const body = res;
    return body;
  }

  private handleError(error: Response | any) {
    console.error('ApiService::handleError', error);
    return throwError(error);
  }

  public cerrarSesion() {
    sessionStorage.removeItem('Token');
    sessionStorage.removeItem('expiracionToken');
    sessionStorage.removeItem('sedeSession');
    sessionStorage.removeItem('Rol');
    sessionStorage.removeItem('Usuario');
    sessionStorage.removeItem('roles');
    sessionStorage.removeItem('numDocumento');
    sessionStorage.removeItem('tipoDocumento');
    sessionStorage.removeItem('hostAPI_UAC');
    sessionStorage.removeItem('hostAPI_ACCVIS');
    sessionStorage.removeItem('hostAPI_FUNCIONARIOS');
    sessionStorage.removeItem('API_WEBSOCKET_TURNOS');
    sessionStorage.removeItem('Nombre');
    sessionStorage.removeItem(ConstantesService.SIA3_SESSSION);
    sessionStorage.removeItem(ConstantesService.ROL_SESSION_SIA3);

    this.usuario = undefined;
    this.apiKey = undefined;
    this.userId = undefined;
    this.userName = undefined;
    this.token = undefined;
    this.rolSeleccionado = undefined;
    this.permisosUsuario = undefined;
  }

  public setIdioma(value) {
    this.itemValue.next(value);
    sessionStorage.setItem('idioma', value);
  }

  public getIdioma() {
    return sessionStorage.getItem('idioma');
  }

  public setUsuario(usuario) {
    this.usuario = usuario;
  }

  public getUsuario() {
    return this.usuario;
  }

  public replaceCardTextLine(text: string) {
    return text
      ? text.replace(new RegExp('\\\\n', 'g'), ', ')
      : 'No Description';
  }

  public setContadorUAC(contador: any) {
    this.contadorUAC.next(contador);
  }

  public setThemeInit() {
    // RECUPERACIÓN VARIABLES sessionStorage
    this.tamanoletra = 100;
    this.style = {
      'font-size': this.tamanoletra + '% !important',
    };
    // Recupera Tema Seleccionado
    this.currentTheme = sessionStorage.getItem('theme');
    if (this.currentTheme == null) {
      this.currentTheme = 'yeti';
    }
    this.theme(this.currentTheme);
  }

  public theme(type) {
    document.body.classList.remove('theme-' + this.currentTheme);
    if (type.theme) {
      this.currentTheme = type.theme;
    } else {
      this.currentTheme = type;
    }

    if (this.currentTheme === 'yeti') {
      this.icon = AssetsService.URL_ICONO_DEMO_JPG;
    } else if (this.currentTheme === 'dark-white') {
      this.icon = AssetsService.URL_ICONO_DEMO_BLACK_PNG;
    } else if (this.currentTheme === 'gris-blanco') {
      this.icon = AssetsService.URL_ICONO_DEMO_GRAY_PNG;
    } else if (this.currentTheme === 'rosa-fucsia') {
      this.icon = AssetsService.URL_ICONO_DEMO_PINK_PNG;
    }
    sessionStorage.setItem('theme', this.currentTheme);
    document.body.classList.add('theme-' + this.currentTheme);
  }

  /**
   *
   * @param estado  valor de estado de conexión
   */
  public setEstadoConexion(estado) {
    this.estadoConexionAplicacion.next(estado);
  }
  /**
   *
   */
  public getEstadoConexion() {
    return this.estadoConexionAplicacion;
  }

  // metodos de SIA3

  public postSIA3Seguro(url: string, cuerpo?: any) {
    let headers = new HttpHeaders();
    headers = this.cargarInformacionSDK(headers);
    const options = { headers };
    return this.http.post(url, cuerpo, options).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }


  public getSIA3Seguro(url: string) {
    let headers = new HttpHeaders();
    headers = this.cargarInformacionSDK(headers);
    const options = { headers };
    return this.http.get(url, options).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );

  }

}
